/**
 * Encabezado estándar de página: ícono coloreado + título + subtítulo opcional + acciones.
 * Usado en Stores, Terminals, Users, etc. para consistencia visual.
 */
export default function PageHeader({ icon: Icon, title, subtitle, color = 'accent', children }) {
  const colorMap = {
    accent:  { box: 'bg-accent/10 border-accent/20',   icon: 'text-accent'      },
    emerald: { box: 'bg-emerald-400/10 border-emerald-400/20', icon: 'text-emerald-400' },
    amber:   { box: 'bg-amber-400/10 border-amber-400/20',     icon: 'text-amber-400'   },
    violet:  { box: 'bg-violet-400/10 border-violet-400/20',   icon: 'text-violet-400'  },
    sky:     { box: 'bg-sky-400/10 border-sky-400/20',         icon: 'text-sky-400'     },
  };
  const c = colorMap[color] || colorMap.accent;

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        {Icon && (
          <div className={`w-9 h-9 rounded-xl border flex items-center justify-center shrink-0 ${c.box}`}>
            <Icon size={18} className={c.icon} />
          </div>
        )}
        <div>
          <h2 className="text-xl font-semibold" style={{ color: 'var(--text-primary)' }}>{title}</h2>
          {subtitle && <p className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>{subtitle}</p>}
        </div>
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
